/* ==========================================================================
   Hemp Heart Product Grid — Carousel behavior
   Works with N sections on one page. No external dependencies.
   ========================================================================== */
(function () {
  function initHHPG(root) {
    var track = root.querySelector('[data-hhpg-track]');
    if (!track) return;

    var prevBtn = root.querySelector('.hhpg-arrow-prev');
    var nextBtn = root.querySelector('.hhpg-arrow-next');
    var dotsWrap = root.querySelector('[data-hhpg-dots]');

    function cardWidth() {
      var card = track.querySelector('.hhpg-card');
      if (!card) return 0;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCards(direction) {
      track.scrollBy({ left: direction * cardWidth(), behavior: 'smooth' });
    }

    function updateArrowState() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function buildDots() {
      if (!dotsWrap) return;
      var cards = track.querySelectorAll('.hhpg-card');
      dotsWrap.innerHTML = '';
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hhpg-dot';
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        dot.addEventListener('click', function () {
          var card = cards[i];
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    function updateActiveDot() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.hhpg-dot');
      var cards = track.querySelectorAll('.hhpg-card');
      var closestIndex = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCards(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCards(1); });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        updateArrowState();
        updateActiveDot();
      });
    }, { passive: true });

    window.addEventListener('resize', updateArrowState);

    buildDots();
    updateArrowState();
    updateActiveDot();
  }

  function initAll() {
    document.querySelectorAll('.hhpg-section').forEach(initHHPG);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify theme editor live re-rendering
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector ? event.target : document;
    var root = section.querySelector ? section.querySelector('.hhpg-section') : null;
    if (root) initHHPG(root);
  });
})();
